import { normalizeMsg, isOffer } from '../../utils/order-book'
import { centrifuge, subTradeAndOrder, subscribe } from '../../utils/socket'
import axios from 'axios'

const _localStorageKey = '_unread'
const setItemIntoStorage = (item) => {
  window.localStorage.setItem(_localStorageKey, JSON.stringify(item))
}
const getItemAndParse = () => {
  const unread = window.localStorage.getItem(_localStorageKey)
  if (!unread || typeof unread !== 'undefined') return {}
  try {
    return JSON.parse(unread)
  } catch (e) {
    return {}
  }
}

export default {
  namespaced: true,
  state: {
    token: null,
    instance: null,
    connected: false,
    pendingSymbol: null,
    currentOrderSub: null,
    currentTradeSub: null,
    unread: getItemAndParse() || {},
  },
  mutations: {
    setCentrifugeToken(state, token) {
      state.token = token
    },
    setCentrifugeInstance(state, instance) {
      state.instance = instance
    },
    setConnectionStatus(state, status) {
      state.connected = status
    },
    increaseUnread(state, symbol) {
      let unread = state.unread
      if (unread[symbol]) unread[symbol]++
      else unread[symbol] = 1
      state.unread = unread
      setItemIntoStorage(state.unread)
    },
    clearUnread(state, symbol) {
      let unread = state.unread
      if (unread[symbol]) unread[symbol] = 0
      state.unread = unread
      setItemIntoStorage(state.unread)
    },
    setOrderSubscription(state, value) {
      state.currentOrderSub = value
    },
    setTradeSubscription(state, value) {
      state.currentTradeSub = value
    },
  },
  actions: {
    setCentToken({ commit }, token) {
      commit('setCentrifugeToken', token)
    },
    setInstance({ commit }, instance) {
      commit('setCentrifugeInstance', instance)
    },
    setStatus({ commit }, instance) {
      commit('setConnectionStatus', instance)
    },
    increase({ commit }, symbol) {
      commit('increaseUnread', symbol)
    },
    clear({ commit }, symbol) {
      commit('clearUnread', symbol)
    },

    async unsubscribeCurrent({ state, commit }) {
      if (!state.connected) return

      console.debug('Unsubscribing from:', state.currentOrderSub, state.currentTradeSub);

      try {
        if (state.currentOrderSub) await state.currentOrderSub.unsubscribe()
        if (state.currentTradeSub) await state.currentTradeSub.unsubscribe()
      } catch (e) {
        console.error('Error unsubscribing:', e)
      } finally {
        commit('setOrderSubscription', null)
        commit('setTradeSubscription', null)
        console.debug('Successfully unsubscribed from previous channels');
      }
    },

    // un-used
    async subscribe({ commit, state }, symbol) {
      const { currentTradeSub, currentOrderSub } = subTradeAndOrder(
        state.instance,
        symbol,
        (chan, data) => this.dispatch(chan, data)
      )

      state.currentTradeSub = currentTradeSub
      state.currentOrderSub = currentOrderSub
    },

    async subscribeToSymbol({ commit, state }, symbol) {
      if (!state.connected || !state.instance) {
        console.debug(`WebSocket not connected. Pending symbol: ${symbol}`)
        state.pendingSymbol = symbol
        return
      }

      console.debug(`Subscribing to symbol: ${symbol}`)

      await this.dispatch('cent/unsubscribeCurrent')

      const { currentTradeSub, currentOrderSub } = subTradeAndOrder(
          state.instance,
          symbol,
          (chan, data) => this.dispatch(chan, data)
      )

      commit('setOrderSubscription', currentOrderSub)
      commit('setTradeSubscription', currentTradeSub)
    },

    // FastComponent дотроос дуудагдана
    async subscribeChannels({ commit, state }, symbol) {
      await this.dispatch('cent/subscribeToSymbol', symbol)
    },

    async resubscribe({ commit, state }) {
      if (state.pendingSymbol) {
        console.debug(`Resubscribing to: ${state.pendingSymbol}`)
        await this.dispatch('cent/subscribeToSymbol', state.pendingSymbol)
        state.pendingSymbol = null
      } else {
        console.debug('No pending symbol to resubscribe')
      }
    },

    async connect({ commit }) {
      try {
        const { data } = await axios.get('/socket/login')
        centrifuge.setToken(data.access_token)
        centrifuge.connect()

        centrifuge.on('connect', async(ctx) => {
          console.debug('socket connected:', ctx);
          commit('setConnectionStatus', true)
          await this.dispatch('cent/resubscribe')
        })
        centrifuge.on('disconnect', (ctx) => {
          console.debug('socket disconnected:', ctx);
          commit('setConnectionStatus', false)
        })

        commit('setCentrifugeToken', data.access_token)
        commit('setCentrifugeInstance', centrifuge)

        // await this.dispatch('cent/unsubscribeCurrent')

        // this.dispatch('cent/resubscribe')
      } catch (e) {
        console.error(e)
      }
    }
  },
}
